/**
 * Single source of truth for the calendar's visual meta:
 * every event TYPE carries a color + a default duration (minutes) + an icon,
 * every participant/event STATUS carries a semantic color.
 * The type VALUES mirror the backend CalendarTypes enum — do not rename.
 * Labels still come from the `calendarTypes.<TYPE>.name` i18n keys.
 */
export const CALENDAR_TYPE_META = [
  { value: 'EVENT',         color: '#7367f0', duration: 60,  icon: 'CalendarIcon' },
  { value: 'APPOINTMENT',   color: '#ff9f43', duration: 30,  icon: 'ClockIcon' },
  { value: 'MEETING',       color: '#4b4b9b', duration: 60,  icon: 'UsersIcon' },
  { value: 'CALL',          color: '#00cfe8', duration: 15,  icon: 'PhoneIcon' },
  { value: 'TASK',          color: '#28c76f', duration: 30,  icon: 'CheckSquareIcon' },
  { value: 'OUT_OF_OFFICE', color: '#e83e8c', duration: 480, icon: 'CoffeeIcon' },
  { value: 'OTHER',         color: '#82868b', duration: 30,  icon: 'MoreHorizontalIcon' },
];

const TYPE_FALLBACK = { value: 'OTHER', color: '#82868b', duration: 30, icon: 'CalendarIcon' };

export function calendarTypeMeta(value) {
  return CALENDAR_TYPE_META.find(t => t.value === value) || TYPE_FALLBACK;
}

export function calendarTypeColor(value) {
  return calendarTypeMeta(value).color;
}

export function calendarTypeDuration(value) {
  return calendarTypeMeta(value).duration;
}

/** Participant / event status colors (APPROVED etc. mirror CalendarStatusEnum). */
export const CALENDAR_STATUS_META = {
  APPROVED: '#28c76f',
  PENDING: '#ff9f43',
  REJECTED: '#ea5455',
  CANCELLED: '#82868b',
};

export function calendarStatusColor(value) {
  return CALENDAR_STATUS_META[value] || '#82868b';
}
